<template>
  <div class="buy-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div class="buy-container">
      <div class="buy-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-shopping-cart title-icon"></i>
              Lista de Compras
            </h1>

            <p class="page-subtitle">Crie e vizualize listas de compras</p>
          </div>

          <div v-if="permission('write', 'buy')" class="actions-section">
            <v-btn class="btn-add-modern" @click="$bvModal.show('buy-create')">
              <i class="fas fa-plus mr-2"></i>
              Nova Lista de Compras
            </v-btn>
          </div>
        </div>
      </div>

      <div class="buy-content">
        <div class="content-card">
          <div class="content-wrapper">
            <v-data-table
              :headers="headers"
              :items="buys"
              item-key="id"
              :footer-props="{
                'items-per-page-options': [25, 50, 75, 100],
                'items-per-page-text': 'Mostrar',
              }"
              class="modern-table"
              :no-data-text="'Nenhuma lista de compras encontrado'"
              :loading-text="'Carregando lista de compras...'"
            >
              <!-- User Column -->
              <template v-slot:[`item.user_name`]="{ item }">
                <div class="user-cell">
                  <div class="user-avatar">
                    <img
                      v-if="item.user_photo_url"
                      :src="item.user_photo_url"
                      :alt="item.user_name"
                      class="user-photo"
                    />
                    <i v-else class="fas fa-user"></i>
                  </div>
                  <div class="user-info">
                    <span class="user-name">{{ item.user_name }}</span>
                  </div>
                </div>
              </template>

              <template v-slot:[`item.type`]="{ item }">
                <div v-if="item.type == 'MEDICINE'">MEDICAMENTO</div>

                <div v-else>PRODUTO</div>
              </template>

              <template v-slot:[`item.date_be_made`]="{ item }">
                <div class="actions-cell">
                  <div v-if="item.date_be_made">
                    {{ moment(item.date_be_made).format("DD/MM/YYYY") }}
                  </div>

                  <div v-else>Não cadastrado</div>
                </div>
              </template>

              <template v-slot:[`item.status`]="{ item }">
                <span
                  class="status-badge"
                  :class="{
                    'status-purchased': item.status == 'COMPRADO',
                    'status-effect': item.status == 'EFETUADO',
                    'status-canceled': item.status == 'PENDENTE',
                  }"
                >
                  {{
                    item.status == "COMPRADO"
                      ? "Comprado"
                      : item.status == "EFETUADO"
                      ? "Efetuado"
                      : item.status == "PENDENTE"
                      ? "Pendente"
                      : ""
                  }}
                </span>
              </template>

              <template v-slot:[`item.action`]="{ item }">
                <div class="actions-cell">
                  <v-btn
                    class="btn-edit-modern"
                    small
                    @click="handleCreated(item.id)"
                  >
                    <i class="fas fa-eye mr-1"></i>
                    Detalhes
                  </v-btn>

                  <v-btn
                    v-if="item.status != 'PENDENTE'"
                    class="print-btn mr-1"
                    small
                    @click="directToPrintViewBuy(item.id)"
                  >
                    <i class="fas fa-print mr-1"></i>
                    Imprimir Lista
                  </v-btn>

                  <v-btn
                    v-if="item.status == 'EFETUADO' && item.finished == 0"
                    class="btn-add-modern mr-1"
                    small
                    @click="handleConfirmed(item.id)"
                  >
                    <i class="fas fa-check-circle mr-1"></i>
                    Confirmar Compra
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>

      <BuyConfirmed @confirmed="getBuys" :buy_id="buy_id_selected" />

      <BuyCreate @created="handleCreated" />
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import BuyCreate from "../templates/Buy/BuyCreate";

import BuyConfirmed from "../templates/Buy/BuyConfirmed";

import routes from "../routes";

import api from "../services/api";

import permission from "../lib/permission";

import moment from "moment";

export default {
  name: "Buy",

  components: {
    NavBar,
    AuthBySessionExpired,
    BuyCreate,
    BuyConfirmed,
  },

  data() {
    return {
      buy_id_selected: null,

      name: null,

      type: null,

      date_be_made: null,

      user_id: null,

      note: null,

      buys: [],

      users: [],

      errors: [],

      headers: [
        {
          text: "CADASTRADO POR",
          value: "user_name",
          sortable: false,
        },
        {
          text: "NOME",
          value: "name",
          sortable: false,
        },
        {
          text: "TIPO",
          value: "type",
          sortable: false,
        },
        {
          text: "DATA PARA COMPRA",
          value: "date_be_made",
          sortable: false,
        },
        {
          text: "STATUS",
          value: "status",
          sortable: false,
        },
        {
          text: "AÇÕES",
          value: "action",
          sortable: false,
        },
      ],
    };
  },

  created() {
    this.getUsers();

    this.getBuys();
  },

  methods: {
    moment,
    permission,

    async getBuys() {
      try {
        this.loading = true;

        const response = await api.get("/buy-all");

        const { buys } = response.data;

        this.buys = buys;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async getUsers() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/users");

        const { error, users } = response.data;

        if (!error) {
          this.users = users;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    directToPrintViewBuy: (buy_id) => {
      let route = routes.resolve({
        name: "buy-print",
        params: {
          buy_id,
        },
      });

      window.open(route.href, "_blank");
    },

    handleCreated(buy_id) {
      this.$router.push(`/buy/${buy_id}`);
    },

    handleConfirmed(buy_id) {
      this.buy_id_selected = buy_id;

      this.$bvModal.show("buy-confirmed");
    },

    handleToBack() {
      routes.go(-1);
    },
  },
};
</script>

<style scoped>
.btn-add-modern {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.4) !important;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
}

.btn-save-modern {
  margin-left: auto;
}

.buy-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.buy-container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px;
}

.buy-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.user-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  border: 2px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.user-name {
  font-weight: 500;
  color: #1e293b;
  font-size: 14px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-purchased {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.status-effect {
  background: linear-gradient(135deg, #dbeafe 0%, #80b9ff 100%);
  color: #2563eb;
  border: 1px solid #3b82f6;
}

.status-canceled {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border: 1px solid #f87171;
}

.buy-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
}

.content-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  min-height: 600px;
}

.content-wrapper {
  padding: 32px;
}

.content-header {
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #e5e7eb;
}

.actions-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.content-title {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
}

.content-description {
  color: #64748b;
  font-size: 16px;
  margin: 0;
  line-height: 1.5;
}

.btn-edit-modern {
  background: linear-gradient(135deg, #1d75be 0%, #155a8a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 12px !important;
  box-shadow: 0 2px 8px rgba(29, 117, 190, 0.25) !important;
  transition: all 0.3s ease !important;
}

.btn-edit-modern:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(29, 117, 190, 0.35) !important;
}

.print-btn {
  background: linear-gradient(135deg, #f59e42 0%, #ea580c 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(245, 158, 66, 0.3) !important;
  transition: all 0.3s ease !important;
}

.print-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(245, 158, 66, 0.4) !important;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .buy-container {
    max-width: 1200px;
  }
}

@media (max-width: 1024px) {
  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .page-title {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .buy-container {
    padding: 0 16px;
  }

  .buy-header {
    padding: 16px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .content-wrapper {
    padding: 24px 20px;
  }

  .content-title {
    font-size: 20px;
  }

  .content-description {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
    flex-direction: column;
    gap: 8px;
  }

  .title-icon {
    font-size: 20px;
  }

  .content-wrapper {
    padding: 20px 16px;
  }

  .content-title {
    font-size: 18px;
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .tab-item {
    min-width: 80px;
    padding: 10px 12px;
    gap: 6px;
  }

  .tab-icon {
    font-size: 14px;
  }

  .tab-label {
    font-size: 9px;
  }
}

.content-wrapper >>> .v-data-table {
  background: transparent !important;
}

.content-wrapper >>> .v-card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid #e5e7eb !important;
}

.content-wrapper >>> .v-btn {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.content-card:empty::before {
  content: "Carregando...";
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #64748b;
  font-size: 16px;
}

.modern-table {
  background: transparent !important;
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
}

.modern-table >>> .v-data-table thead th {
  background-color: #f8fafc !important;
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-bottom: 2px solid #e5e7eb !important;
  padding: 16px !important;
}

.modern-table >>> .v-data-table tbody tr {
  transition: all 0.2s ease !important;
}

.modern-table >>> .v-data-table tbody tr:hover {
  background-color: #f8fafc !important;
}

.modern-table >>> .v-data-table tbody td {
  padding: 16px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}
</style>